'use client';

import styled from 'styled-components';

import { Spacers } from '@styles/theme';

export const InformationFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacers.XS}rem;
  background-color: ${({ theme }) => theme.colors.backgroundAccent};
  border-radius: ${Spacers.XS}rem;
  padding: ${Spacers.BASE}rem;
  align-items: center;
  text-align: center;
  color: ${({ theme }) => theme.colors.typographyBodyLight};

  & div {
    max-width: 20.5rem;
    width: auto;
  }
`;